// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1342B","comment":"styles_comment__2R0NE"};